<template>
  <div class="home">
    <div class="homeBox">

      <div class="chartBox">
        <div class="box-card" style="margin-top: 20px">
          <div id="c1" class="c1">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Chart} from '@antv/g2';
import _ from 'lodash'

export default {
  name: "dataH5Two",
  mounted() {
    // 获取数据
    this.getData();
  },
  data() {
    return {
      chart1: null,
      resData: {},
      areaData: [],
      searchData: {  //搜索条件
        city: this.$route.query.city || null,
        door: this.$route.query.door || null,
        mold: this.$route.query.mold || null,  //1季度  2月
        region: this.$route.query.region || null,
        type: this.$route.query.type || null,  // 1全国 2大区 3城市 4单店
        value: this.$route.query.value || null,
        year: this.$route.query.year || null
      },
    }
  },
  watch: {
    '$route'(to, from) {
      this.getData()
    }
  },
  methods: {
    resetSearch() {
      this.dateSelect = null
    },
    async getData() {
      let city = this.$route.query.city || null;
      let door = this.$route.query.door || null;
      let mold = this.$route.query.mold || null;  //1季度  2月
      let region = this.$route.query.region || null;
      let type = this.$route.query.type || null;  // 1全国 2大区 3城市 4单店
      let value = this.$route.query.value || null;
      let year = this.$route.query.year || null;
      this.searchData.city = city;
      this.searchData.door = door;
      this.searchData.mold = mold;
      this.searchData.region = region;
      this.searchData.type = type;
      this.searchData.value = value;
      this.searchData.year = year;
      let res = await axios.post(oprReqUrl+"api/trend", this.searchData);
      res = res.data
      if (res.code === 200) {
        this.resData = res.data
        // todo: 临时数据
        // let resTemp = JSON.parse('{"code":200,"message":"SUCCESS","data":{"reportName":"全国报告2021.8","score":{"description":"得分情况","now":0.7445736842,"previous":0.7986100000},"role":{"description":"评估者占比","list":[{"name":"Admin","value":2},{"name":"HC","value":6},{"name":"HM","value":1},{"name":"RO","value":1},{"name":"TTT","value":1},{"name":"VMS","value":1},{"name":"总部NSAE","value":1},{"name":"总部VMS","value":6}],"TTL":19},"trend":{"description":"得分趋势图","data":[{"name":"2021.8","value":0.7445736842},{"name":"2021.7","value":0.7986100000},{"name":"2021.6","value":0.7464400000}]},"action":{"description":"行动完成情况","nofinish":3,"finishpass":3,"finishnopass":0,"timeout":1,"total":6},"finishrate":{"description":"区域评估完成率","data":[{"total":3,"previousfinish":2,"regionName":"大北京","finish":3,"regionNO":"31A3FFC424BJ"},{"total":2,"previousfinish":0,"regionName":"大湾区","finish":2,"regionNO":"D0121EB7DBA7"},{"total":2,"previousfinish":0,"regionName":"成渝","finish":2,"regionNO":"FB8F759047A3"},{"total":2,"previousfinish":0,"regionName":"大上海","finish":2,"regionNO":"FB8F759047SH"}]},"scoredistribute":{"description":"区域得分分布","data":[{"name":"成渝","lt60":0,"gt90":2,"gt80":0,"gt60":0,"avg":0.9594500000},{"name":"大北京","lt60":1,"gt90":1,"gt80":0,"gt60":1,"avg":0.6570909091},{"name":"大上海","lt60":1,"gt90":1,"gt80":0,"gt60":0,"avg":0.6438500000},{"name":"大湾区","lt60":0,"gt90":1,"gt80":1,"gt60":0,"avg":0.9280750000}]},"customerfinish":{"description":"客户评估完成率","data":[{"total":1,"resellerName":"Others","previousfinish":0,"finish":1,"resellerNO":"DF5F2013B157"},{"total":8,"resellerName":"TOPSPORTS","previousfinish":2,"finish":8,"resellerNO":"F2EC073385F6"}]},"customerscore":{"description":"客户得分分布","data":[{"lt60":0,"avg":1.0000000000,"gt90":1,"gt80":0,"gt60":0,"name":"Others"},{"lt60":2,"avg":0.7303833333,"gt90":4,"gt80":1,"gt60":1,"name":"TOPSPORTS"},{"lt60":2,"avg":0.7303833333,"gt90":4,"gt80":1,"gt60":1,"name":"test"},{"lt60":2,"avg":0.7303833333,"gt90":4,"gt80":1,"gt60":1,"name":"ttt"},{"lt60":2,"avg":0.7303833333,"gt90":4,"gt80":1,"gt60":1,"name":"aaaa"},{"lt60":2,"avg":0.7303833333,"gt90":4,"gt80":1,"gt60":1,"name":"bbbb"},{"lt60":2,"avg":0.7303833333,"gt90":4,"gt80":1,"gt60":1,"name":"ccccc"}]},"analyse":{"description":"大项得分分析","nowVMS":0.7169315789,"preVMS":0.8270300000,"nowOPERATION":0.5274526316,"preOPERATION":0.7666600000,"nowTRAINING":0.5157894737,"preTRAINING":0.7733400000},"checkitem":{"description":"检查项目得分分析","data":[{"a":73,"b":23,"c":96,"d":0.7604,"name":"货品陈列"},{"a":47,"b":9,"c":56,"d":0.8393,"name":"模特、板墙及道具陈列"},{"a":26,"b":6,"c":32,"d":0.8125,"name":"后期检查维护"},{"a":45,"b":11,"c":56,"d":0.8036,"name":"市场活动"},{"a":0,"b":0,"c":0,"name":"BE A COACH精英教练"},{"a":11,"b":5,"c":16,"d":0.6875,"name":"反馈"},{"a":0,"b":0,"c":0,"name":"SFL2.0领导力2.0"},{"a":33,"b":7,"c":40,"d":0.8250,"name":"后场管理"},{"a":0,"b":0,"c":0,"name":"SYPB全力以服"},{"a":38,"b":7,"c":45,"d":0.8444,"name":"前场整洁"},{"a":0,"b":0,"c":0,"name":"ATHLETE 15培训日历"},{"a":35,"b":5,"c":40,"d":0.8750,"name":"后仓有序"},{"a":1,"b":0,"c":1,"d":1.0000,"name":"耐克学道GET IT"},{"a":10,"b":2,"c":12,"d":0.8333,"name":"LISTEN U零听"},{"a":0,"b":0,"c":0,"name":"DNA课程"},{"a":2,"b":0,"c":2,"d":1.0000,"name":"STO Download开季培训"},{"a":18,"b":2,"c":20,"d":0.9000,"name":"NIKE工服"},{"a":3,"b":0,"c":3,"d":1.0000,"name":"Selling Skills销售技巧"}]},"superiority":{"description":"优势与机会点","advantage":[{"a":3,"b":0,"c":3,"d":1.0000,"e":0.8889,"name":"Selling Skills销售技巧"},{"a":1,"b":0,"c":1,"d":1.0000,"e":0.7333,"name":"耐克学道GET IT"},{"a":2,"b":0,"c":2,"d":1.0000,"e":0.8333,"name":"STO Download开季培训"},{"a":18,"b":2,"c":20,"d":0.9000,"e":0.7833,"name":"NIKE工服"},{"a":35,"b":5,"c":40,"d":0.8750,"e":0.8083,"name":"后仓有序"}],"chance":[{"checkitem":"DNA课程","a":0,"b":0,"c":0,"question":"运动员是否都有自己的DNA场地记录？","d":0,"e":0.8667},{"checkitem":"SYPB全力以服","a":0,"b":0,"c":0,"question":"店铺是否参加SYPB项目？","d":0,"e":0.6667},{"checkitem":"ATHLETE 15培训日历","a":0,"b":0,"c":0,"question":"运动员是否了解当天的 ATHLETE 15 培训主题？","d":0,"e":0.8000},{"checkitem":"BE A COACH精英教练","a":0,"b":0,"c":0,"question":"后仓或休息室内，是否有店铺的愿景和价值观？","d":0,"e":0.4667},{"checkitem":"SYPB全力以服","a":0,"b":0,"c":0,"question":"店铺是否有在后仓或员工休息室装置 SYPB 海报？","d":0,"e":0.6667}]}}}')
        // this.resData = resTemp.data

        // 得分趋势图
        this.renderC1();
      }
    },
    renderC1() {
      let res = this.resData.trend.data;
      let trendData = []
      res.forEach((item) => {
        let row = {date: item.name, value: this.numberPercentageFormat(item.value)}
        trendData.unshift(row)
      })
      const data = trendData;

      if (this.chart1 != null) {
        this.chart1.data(data)
        this.chart1.render()
        return
      }
      const chart = new Chart({
        container: 'c1',
        autoFit: true,
        height: 200,
        padding: 50,
      });

      chart.data(data);
      chart.scale({
        date: {
          range: [0, 1],
        },
        value: {
          min: 0,
          max: 110,
          nice: true,
        },
      });

      chart.tooltip({
        showCrosshairs: false, // 是否展示 Tooltip 辅助线
        shared: true,
        grid: {bottom: '10%', containLabel: true},
        xAxis: {
          axisLabel: {interval: 0}
        }
      });

      const geometry1 = chart.line().position('date*value').label('value');
      const geometry2 = chart.point().position('date*value');
      geometry1.color('#67C23A');
      geometry2.color('#67C23A');
      geometry1.label(
        'value',
        (val) => {
          return {
            content: val,
          };
        },
        {
          type: 'base', // 声明 label 类型
        }
      );

      chart.axis('value', false);
      chart.axis('date', {
        label: {
          offset: 5
        }
      });
      // chart.render();
      this.chart1 = chart
      this.chart1.render()
    },

    numberFormat(data) {
      if (typeof (data) == "undefined" || data == null) {
        data = 0
      }
      let res = (data * 1).toFixed(1) * 1
      return res
    },
    numberPercentageFormat(data) {
      if (typeof (data) == "undefined" || data == null) {
        data = 0
      }
      let res = (data * 1 * 100).toFixed(1) * 1
      return res
    },
  }
};
</script>

<style lang="sass" scoped>
.home
  width: 100%
  overflow: auto
  background: #fff

.homeBox
  padding: 20px

  .chartBox
    .title
      font-size: 14px

    .c1
      height: 200px

</style>



// WEBPACK FOOTER //
// src/opr/pages/views/dataH5Two.vue